"use client";

import { useEffect, useRef, useState } from "react";

import { cn } from "@/lib/utils";

interface AnimatedBgSvgProps {
  className?: string;
}

export function AnimatedBgSvg({ className }: AnimatedBgSvgProps) {
  const svgRef = useRef<SVGSVGElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    if (svgRef.current) {
      observer.observe(svgRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <svg
      ref={svgRef}
      width="1456"
      height="2049"
      viewBox="0 0 1456 2049"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-auto w-full shrink-0", className)}
    >
      <style>
        {`
          @keyframes tracePath {
            from {
              stroke-dashoffset: var(--path-length);
            }
            to {
              stroke-dashoffset: 0;
            }
          }
          .trace-path {
            stroke-dasharray: var(--path-length);
            stroke-dashoffset: var(--path-length);
          }
          .trace-path.animate {
            animation: tracePath 2s ease-out forwards;
          }
          .trace-path-delayed {
            animation-delay: 0.3s;
          }
          .trace-path-delayed-2 {
            animation-delay: 0.6s;
          }
          .trace-path-delayed-3 {
            animation-delay: 0.9s;
          }
        `}
      </style>
      <mask
        id="mask0_181_1192"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="1456"
        height="2049"
      >
        <rect width="1456" height="2049" fill="#0006B7" />
      </mask>
      <g mask="url(#mask0_181_1192)">
        {/* Main decorative path */}
        <path
          className={cn("trace-path", isVisible && "animate")}
          style={{ "--path-length": "15000" } as React.CSSProperties}
          d="M272.316 106.138C351.104 -30.3863 508.728 -143.346 683.864 -139.399L683.863 -139.398C698.074 -139.321 712.027 -138.644 726.236 -137.401H726.242C937.974 -116.245 1074.39 11.5022 1173.55 171.095C1216.3 148.607 1269.35 144.59 1319.68 155.563C1370.17 166.57 1417.99 192.671 1450 230.42L1451.57 232.138C1454.69 235.577 1457.7 239.045 1460.7 242.635L1462.19 244.44L1462.21 244.456L1462.22 244.474C1575.01 407.016 1516.27 576.064 1460.6 713.448L1460.6 713.468C1454.91 725.94 1448.92 738.158 1442.42 750.236L1442.42 750.239C1441.16 752.537 1439.58 754.652 1437.71 756.498C1439.45 758.214 1440.95 760.18 1442.17 762.292L1442.42 762.747L1442.42 762.752C1448.52 774.087 1454.16 785.534 1459.53 797.187L1460.6 799.521L1460.6 799.54C1516.27 936.925 1575.01 1105.98 1462.22 1268.51L1462.21 1268.53L1462.2 1268.55C1458.19 1273.4 1454.22 1277.99 1450 1282.57C1417.99 1320.32 1370.17 1346.42 1319.68 1357.42C1269.35 1368.4 1216.3 1364.38 1173.55 1341.89C1074.39 1501.5 937.974 1629.24 726.242 1650.39L726.236 1650.39C712.027 1651.64 698.074 1652.32 683.863 1652.4C508.728 1656.33 351.104 1543.37 272.316 1406.86V1406.86C265.263 1395.08 258.63 1383.07 252.48 1370.88C194.162 1368.17 134.016 1356.62 78.1426 1329.89L78.1357 1329.88L78.1289 1329.88C-20.3377 1279.06 -65.4955 1196.99 -82.6592 1108.63C-99.8187 1020.29 -89.0034 925.645 -75.5322 849.586L-75.5312 849.58C-69.5754 818.08 -62.2397 786.989 -53.8975 756.499C-62.2395 725.997 -69.5756 694.907 -75.5312 663.407L-75.5322 663.401C-89.0034 587.348 -99.8187 492.7 -82.6592 404.36C-65.4955 315.999 -20.3379 233.932 78.1289 183.12L78.1426 183.114C134.016 156.378 194.162 144.818 252.48 142.104C258.629 129.912 265.263 117.911 272.316 106.138ZM1314.31 891.284C1034.66 1128.62 710.858 1332.11 322.757 1367.35C418.919 1475.14 549.419 1547.74 683.301 1545.26H683.308C694.454 1545.21 705.473 1544.73 716.762 1543.77L716.77 1543.77H716.776C875.273 1534.82 987.946 1443.03 1079.51 1317.49C1170.61 1192.59 1240.75 1034.39 1314.31 891.284ZM1407.62 818.354C1377.55 887.081 1348.16 966.417 1315.27 1048.31C1282.26 1130.51 1245.74 1215.27 1201.54 1294.37C1273.25 1290.82 1326.86 1258.19 1370.36 1210.72V1210.71C1373.31 1207.5 1376.15 1204.26 1379.07 1200.81L1379.86 1199.81C1413.36 1157.17 1426.83 1095.86 1428.64 1028.14C1430.46 960.429 1420.63 886.385 1407.62 818.354ZM-9.6709 788.903C-10.8439 803.957 -13.6268 842.243 -14.3047 856.735V856.738C-18.3445 933.16 -14.7415 1015.95 5.14258 1085.69C24.8723 1154.89 60.6033 1211.15 120.711 1235.67L122.136 1236.25L122.151 1236.25C165.887 1255.3 215.798 1263.76 267.403 1265.08C638.551 1251.08 1036.17 1019.06 1345.46 788.903L-9.6709 788.903ZM267.403 247.908C215.798 249.238 165.887 257.689 122.151 276.735L122.144 276.739L122.136 276.742C61.1672 300.955 25.0277 357.557 5.14258 427.299C-14.4309 495.948 -18.2278 577.244 -14.4883 652.663L-14.3047 656.25V656.253C-13.2777 677.989 -11.6876 699.814 -9.67773 721.641L1345.47 721.641C1034.42 488.879 642.136 262.047 267.403 247.908ZM1201.54 218.621C1245.74 297.726 1282.26 382.484 1315.27 464.685C1348.16 546.581 1377.55 625.912 1407.62 694.634C1420.63 626.602 1430.46 552.562 1428.64 484.854C1426.81 416.605 1413.15 354.868 1379.07 312.189V312.188C1376.15 308.729 1373.31 305.488 1370.36 302.286L1370.36 302.285C1326.86 254.812 1273.25 222.182 1201.54 218.621ZM683.301 -32.2773C549.419 -34.738 418.92 37.8468 322.758 145.65C710.858 180.878 1034.66 384.377 1314.31 621.716C1240.75 478.612 1170.61 320.409 1079.51 195.506C987.946 69.9724 875.272 -21.8216 716.776 -30.7803L716.763 -30.7813C705.473 -31.7271 694.454 -32.2125 683.307 -32.2764L683.301 -32.2773Z"
          stroke="#3561FF"
        />
        {/* Vertical lines */}
        <path
          className={cn(
            "trace-path trace-path-delayed",
            isVisible && "animate",
          )}
          style={{ "--path-length": "2650" } as React.CSSProperties}
          d="M130.859 62L130.859 2712"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed",
            isVisible && "animate",
          )}
          style={{ "--path-length": "2650" } as React.CSSProperties}
          d="M428.012 62L428.012 2712"
          stroke="#3561FF"
        />
        {/* Border rectangle */}
        <rect
          className={cn(
            "trace-path trace-path-delayed-2",
            isVisible && "animate",
          )}
          style={{ "--path-length": "8016" } as React.CSSProperties}
          x="48.5"
          y="62.5"
          width="1359.04"
          height="2649"
          stroke="#3561FF"
        />
        {/* Horizontal lines */}
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 124.859H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 1120H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 324H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 1319H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 523H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 1518H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 722H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 1717H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 921H1406.1"
          stroke="#3561FF"
        />
        <path
          className={cn(
            "trace-path trace-path-delayed-3",
            isVisible && "animate",
          )}
          style={{ "--path-length": "1356" } as React.CSSProperties}
          d="M49.9414 1916H1406.1"
          stroke="#3561FF"
        />
      </g>
    </svg>
  );
}
